export default {
  descricao: {
    value: null,
    required: true,
    state: null
  },
  tipo: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  itemInicio: {
    value: false,
    required: true,
    state: null
  },
  itemFim: {
    value: false,
    required: true,
    state: null
  },
  dfd: {
    value: false,
    required: true,
    state: null
  },
  status: {
    value: 1
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/copitem/copitem-form.js